import { render, staticRenderFns } from "./PortfolioSummaryTree.vue?vue&type=template&id=6a50c7bc&scoped=true&"
import script from "./PortfolioSummaryTree.vue?vue&type=script&lang=js&"
export * from "./PortfolioSummaryTree.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSummaryTree.vue?vue&type=style&index=0&id=6a50c7bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50c7bc",
  null
  
)

export default component.exports